"use client";

import { useState } from "react";
import { Lock, Unlock } from "lucide-react";
import { useUser } from "@/app/context/UserContext";
import Accordion from "../Elements/Accordion";
import ToggleSwitch from "../Elements/Core/ToggleSwitch";
import UserPermissions from "./UserPermissions";
import IdentifierFieldConfigForm from "./LoginDisabled/IdentifierFieldConfigForm";

export default function ItemPermissions() {
  const { userProject, setUserProject } = useUser();

  const [openPrivate, setOpenPrivate] = useState(false);
  const [openAnonymous, setOpenAnonymous] = useState(false);
  const [openGenericAccess, setOpenGenericAccess] = useState(false);

  const handlePrivateAccess = (checked: boolean) => {
    setUserProject((prev: any) => ({
      ...prev,
      project: {
        ...prev.project,
        private_access: checked,
      },
    }));
  };

  const handleAnonymousAccess = (checked: boolean) => {
    setUserProject((prev: any) => ({
      ...prev,
      project: {
        ...prev.project,
        loggin_disabled: checked,
        loggin_disabled_detail: checked
          ? {
              solicitar_identificador: false,
            }
          : undefined,
      },
    }));
  };

  //const handleGenericAccess = (checked: boolean) => {
  //  setUserProject((prev: any) => ({
  //    ...prev,
  //    project: {
  //      ...prev.project,
  //      generic_access: checked,
  //        
  //    },
  //  }));
  //};


  return (
    <div className="space-y-3 p-8">
      <Accordion
        title="Convertir en privado"
        index={0}
        isOpen={openPrivate}
        onClick={() => setOpenPrivate((v) => !v)}
        icon={<Lock className="w-4 h-4" />}
        className="border border-gray-200 rounded-2xl overflow-hidden n-elevation-1"
        classNameHead="w-full flex justify-between items-center bg-gray-100 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-all"
        rightComponent={
          <ToggleSwitch
            checked={userProject.project.private_access}
            onChange={handlePrivateAccess}
          />
        }
      >
        <div className="p-8"> 
           <UserPermissions/>
        </div>
      </Accordion>

      {/*}
      <Accordion
        title="Permitir Acceso Genérico"
        index={2}
        isOpen={openGenericAccess}
        onClick={() => setOpenGenericAccess((v) => !v)}
        icon={<Lock className="w-4 h-4" />}
        className="border border-gray-200 rounded-2xl overflow-hidden n-elevation-1"
        classNameHead="w-full flex justify-between items-center bg-gray-100 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-all"
        rightComponent={
          <ToggleSwitch
            checked={userProject.project.generic_access??false}
            onChange={handleGenericAccess}
          />
        }
      >
        <div className="p-8">
          <IdentifierFieldConfigForm />
        </div>
      </Accordion>
      */}


      <Accordion
        title="Permitir acceso anónimo"
        index={1}
        isOpen={openAnonymous}
        onClick={() => setOpenAnonymous((v) => !v)}
        icon={<Unlock className="w-4 h-4" />}
        className="border border-gray-200 rounded-2xl overflow-hidden n-elevation-1"
        classNameHead="w-full flex justify-between items-center bg-gray-100 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-all"
        rightComponent={
          <ToggleSwitch
            checked={userProject.project.loggin_disabled??false}
            onChange={handleAnonymousAccess}
          />
        }
      >
        <div className="p-8">
          <IdentifierFieldConfigForm />
        </div>
      </Accordion>

    </div>
  );
}
